import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { OfficialDiaryPublicationProvider } from './context/official-diary-publication-context';
import { OfficialDiaryPublicationComponent } from './official-diary-publication-component';

export function OfficialDiaryPublicationFactory() {
    return (
        <BaseLayoutFactory>
            <OfficialDiaryPublicationProvider>
                <OfficialDiaryPublicationComponent />
            </OfficialDiaryPublicationProvider>
        </BaseLayoutFactory>
    );
}
